import { findAncestor } from '../utils/dom';
const initAccordion = (): void => {
  const accordionToggles = document.querySelectorAll('[data-accordion-title]');
  if (!accordionToggles.length) return;

  accordionToggles.forEach((toggle: HTMLElement) => {
    toggle.addEventListener('click', () => {
      // close other accordions
      const accordionItems = document.querySelectorAll('[data-accordion-item]');

      // Open this accordion
      const parent = findAncestor(toggle, 'accordionItem');
      if (parent) {
        if (parent.classList.contains('accordion--open')) {
          parent.classList.remove('accordion--open');
        } else {
          accordionItems.forEach(item => item.classList.remove('accordion--open'));
          parent.classList.add('accordion--open');
        }
      }
    })
  })
}

export default initAccordion;
